export const resolveFunctionOrValue = (value: any, ...functionValues: any[]) => {
  if (typeof value === 'function') {
    return value(...functionValues)
  }
  return value
}
